<template>
	<div class="steps-screen">
		<div class="step-content">
      <div class="step-question-head-block">
        <div class="step-question-block">
          <div class="step-question"
               :class=" Object.keys(this.step.answer).length < 3? 'step-question-row' : 'step-question'">
            <div class="step-question-annotation">
              {{ step.question }}
            </div>
            <div></div>
          </div>
          <div v-if="Object.keys(this.step.answer).length < 3" class="step-options-row">
            <div class="btn-action-row" v-for="(answer, index) in step.answer">
              <div class="btn-action-row-item" @click="selectRowAnswer(answer.id, index)" :key="index"
                   :class="answer.active ? 'btn-action-row-active' : ''">
                <div class="row-option-selected" v-if="answer.active">
                  <img src="/public/application/modules/requests/front/assets/check.svg" alt="">
                </div>
                {{ answer.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="step-question-underline" :style="{ backgroundColor: underlineColor }"></div>
      </div>

      <!--      блок аннотаций и кнопки завершения-->
      <div class="main-step-content">
        <div class="step-annotation-content">
          <div>
            <!--        для случая если больше 2 ответов -->
            <div v-if="Object.keys(this.step.answer).length > 2"  class="step-options-column">
              <div class="btn-action-col" v-for="(answer, index) in step.answer">
                <div class="checkbox">
                  <label>
                    <input type="checkbox"
                           class="answer-checkbox"
                           v-model="answer.active"
                           @click="seelectAnswer(answer.id, index)"
                           :key="index">{{ answer.name }}
                  </label>
                </div>
              </div>
            </div>

            <div class="step-question-description"
                 v-if="step.annotation"
                 v-html="step.annotation">
            </div>
          </div>
          <div>
            <div class="step-result">
              <div  v-if="stepIndex + 1 < stepCount && Object.keys(this.step.answer).length > 2"
                    class="step-btn"
                    @click="checkResult">
                Далее
              </div>
              <div v-if="stepIndex + 1 === stepCount && Object.keys(this.step.answer).length > 2"
                   class="start-step-btn start-step-btn-hover"
                   @click="checkResult">
                Завершить опрос
              </div>
            </div>
          </div>
        </div>

        <div class="svg-block-container">
          <div class="svg-area">
            <img class="svg-area-img" v-bind:src="svgImage" alt="start_icon">
          </div>
        </div>
      </div>
		</div>

		<transition name="bounce">
			<span v-if="is_show_help" class="step-result-text">
				Для перехода к следующему шагу ответьте на вопрос выше
			</span>
		</transition>
	</div>
</template>

<script>
	export default {
		props: ['step','stepIndex','stepCount', 'svgIndex', 'svgImage', 'underlineColor'],
		data() {
		  let currentStep = this.stepIndex + 1;
      this.svgIndex = currentStep < 4 ? currentStep : (currentStep - 1) % 4 + 1;
      this.svgImage = "/public/images/files/front/frame" + this.svgIndex + ".svg";
      switch (this.svgIndex) {
        case 1:
          this.underlineColor = '#AAC75F'
          break;
        case 2:
          this.underlineColor = '#D85C39'
          break;
        case 3:
          this.underlineColor = '#F1BC41'
          break;
        case 4:
          this.underlineColor = '#00A9D4'
      }

			return {
				is_show_help: false
			}
		},
		methods:{
      selectRowAnswer(answer_id, index) {
        let value = true;
        if(this.step.answer[index].active) {
          value = false;
        }

        if(value && this.step.option == 1) {
          for(let ind in this.step.answer) {
            if(index == ind) {
              continue;
            }
            this.$set(this.step.answer[ind], 'active', false);
          }
        }

        this.$set(this.step.answer[index], 'active', value);

        this.checkResult();
      },
			seelectAnswer(answer_id, index) {
				let value = true;
				if(this.step.answer[index].active) {
					value = false;
				}

				if(value && this.step.option == 1) {
					for(let ind in this.step.answer) {
						if(index == ind) {
							continue;
						}
						this.$set(this.step.answer[ind], 'active', false);
					}
				}

				this.$set(this.step.answer[index], 'active', value);

			},
			checkResult() {
				let result = [];
				for(let ind in this.step.answer) {
					if(this.step.answer[ind].active) {
						result.push(this.step.answer[ind].id);
					}
				}

				if( result.length == 0 ) {
					this.is_show_help = true;
				} else {
					this.is_show_help = false;
					for(let ind in this.step.answer) {
						this.step.answer[ind].active = false;
					}
					this.$emit('onResultStep', result);
				}
			}
		}
	}
</script>

<style scoped>
	.steps-screen {
    color: #2E313D;
    border: 1px solid #E0E0E0;
    box-shadow: 0 6px 6px rgba(0, 0, 0, 0.15);
		display: flex;
		flex-direction:column;
    width: 100%;
	}

  .step-question-block{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 1%;
    min-height: 52px;
  }

  .svg-area-img{
    width: auto;
    height: 100%;
  }

  .svg-block-container{
    width: 28%;
    min-height: 220px;
  }

  .step-annotation-content{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .answer-checkbox {
    margin: 4px 8px 0 0;
  }

  .main-step-content{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .step-question-underline{
    height: 6px;
  }

  .step-question-head-block{
    margin-bottom: 2%;
  }

  .start-step-btn {
    margin-top: 30px;
    margin-bottom: unset;
    text-align: center;
    padding: 12px;
    background-color: #DD262E;
    cursor: pointer;
    border-radius: 3px;
    font-weight: 300;
    font-size: 18px;
    letter-spacing: 0.15px;
    color: #FFFFFF;
    min-width: 248px;
    height: 48px;
  }

  .start-step-btn-hover:hover {
    background-color: #FE6767;
  }

	.step-content {
		display: flex;
    flex-direction: column;
		flex-wrap: wrap;
		padding: 15px;
    /* убрать в медиа*/
		min-height: 300px;
	}

  .step-question{
    display: flex;
    align-items: center;
  }

	.step-question-annotation {
		font-size: 22px;
	}

  .step-options-row{
    width: 30%;
    display: flex;
    flex-direction:row;
    justify-content: right;
    align-items: center;
  }

  .row-option-selected{
    position:absolute;
    left: 5px;
    top: 8px;
  }

	.option-selected img {
		width: 32px;
	}

  .row-option-selected img {
		width: 32px;
	}

  .btn-action-row-item{
    text-transform: uppercase;
    width: 100%;
    padding: 15px 0;
    text-align: center;
    position: relative;
    font-weight: bold;
    font-size: 16px;
    background: #08AAD4;
    border-radius: 3px;
    color: #FFFFFF;
    cursor: pointer;
  }

  .answer-checkbox{
    cursor: pointer;
  }
  .answer-checkbox:hover{
    cursor: pointer;
  }

  .btn-action-row {
    min-width: 30%;
    margin-left: 15px;
  }

	.btn-action:hover, .step-btn:hover, .btn-action-active, .btn-action-row-active {
		background-color: #1396BE;
	}
  .btn-action-row-item:hover{
    background-color: #1396BE;
  }

	.step-result {
		display: flex;
		justify-content:left;
	}

	.step-result-text {
		width: 100%;
		text-align: center;
		margin-top: -20px;
	}

	.step-btn {
    margin-top: 30px;
    margin-bottom: unset;
    text-align: center;
    padding: 12px;
    background-color: #08aad4;
    cursor: pointer;
    border-radius: 3px;
    font-weight: 300;
    font-size: 18px;
    letter-spacing: 0.15px;
    color: #FFFFFF;
    width: 248px;
    height: 48px;
    text-transform: unset;
	}

  @media (max-width: 1070px) {

    .svg-area{
      width: 100%;
      height: 100%;
    }

    .svg-block-container, .step-annotation-content{
      width: 48%;
    }

    .step-options-row{
      width: 50%;
    }

  }

	@media (max-width: 950px) {

    .step-question{
      width: 100%;
      text-align: center;
    }

    .step-options-row{
      width: 100%;
      justify-content: center;
      align-items: center;
    }

		.step-content {
			justify-content:center;
		}

    .step-question-block {
      flex-direction: column;
    }
    .svg-area{
      width: 100%;
      height: 100%;
    }

    .svg-block-container, .step-annotation-content {
      width: 48%;
    }
	}

	@media (max-width: 600px) {

    .step-content {
      display:unset;
    }

    .steps-screen {
      min-height: 600px;
      width: 100%;
    }

    .main-step-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .step-result {
      justify-content:center;
    }

    .svg-area {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
    }

    .svg-area-img {
      width: unset;
    }

    .step-question-block {
      flex-direction: column;
    }

    .btn-action-row {
      margin-left: unset;
      width: 100%;
    }

    .btn-action-row-item {
      margin-top: 4px;
    }

    .svg-block-container, .step-annotation-content {
      width: unset;
    }

    .step-options-row {
      flex-direction: column;
    }
	}

	@keyframes bounce-in {
	  0% {
	    transform: scale(0);
	  }
	  50% {
	    transform: scale(1.5);
	  }
	  100% {
	    transform: scale(1);
	  }
	}
</style>



// WEBPACK FOOTER //
// src/components/StepsScreen.vue